<template>


<nav  v-if="loginState === true">

          <v-app-bar color="primary" fixed app>
             <v-toolbar-title>

            <router-link to="/home" v-if="loginState === true">
            <h5 v-if="$vuetify.breakpoint.xs" class="m4u_text--text " align="center">
              <v-icon class="m4u_text--text">mdi-home</v-icon>
            </h5> <img src="../assets/Logo.png" height="40em"/>
         </router-link>
             </v-toolbar-title>
                               <v-spacer>

                  </v-spacer>
              <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
             <v-btn
               icon x-large class="primary newmembtn"  to="/newmemory" 
                       v-bind="attrs"
                        v-on="on">
          <v-icon class="m4u_text--text">mdi-plus-circle</v-icon></v-btn>
                </template>
                <span secondary>New Memory</span>
              </v-tooltip>
                  <v-spacer>

                  </v-spacer>

          <div>
            <v-btn fab class="primary notification" v-if="alertBell && loginState === true" v-bind="predefinedBtnProps[$vuetify.breakpoint.name]">
              <v-icon class="black--text">mdi-bell-ring</v-icon>
            </v-btn>


          </div>
          <div>
               <v-btn small class="primary m4u_text--text text-center" :to="{name: 'Invitation'}" v-bind="predefinedBtnProps[$vuetify.breakpoint.name]" 
                v-if="loginState === true && (user.UserSubType === 2 || user.UserSubType === 3)">
                  Invite</v-btn> 
          </div>
  <v-app-bar-nav-icon @click="drawer = true" class="m4u_text--text" v-if="loginState === true"></v-app-bar-nav-icon>
          </v-app-bar>
          <v-navigation-drawer v-model="drawer" fixed temporary right>
            <v-list dense>
              <v-list-item-group  active-class="m4u_text--text text--accent-4">
                <span class="userName m4u_text--text"> {{user.UserDisplayName}} </span> 
                <span><v-btn @click="drawer=false" small class="primary ml-5">
                  <v-icon class="m4u_text--text">mdi-close</v-icon>
                  </v-btn></span>
                <div v-for="link in links" :key="link.text" >
                <v-list-item @click="goToRoute(link.route)" >
                  <v-list-item-icon>
                    <v-icon class="m4u_text--text">{{link.icon}}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="m4u_text--text">{{link.text}}</v-list-item-title>
                </v-list-item>
              </div>
            <v-list-item @click="goToProfile()">
              <v-list-item-icon>
                <v-icon class="m4u_text--text">mdi-account-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="m4u_text--text">Profile</v-list-item-title>
            </v-list-item>
            <v-list-item @click="goTo30Days()" v-if="user.UserSubType !== 2 && user.UserSubType !== 3 && user.UserSubType !== 4">
              <v-list-item-icon>
                <v-icon class="m4u_text--text">mdi-currency-usd</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="m4u_text--text">Get 30 Days Free</v-list-item-title>
            </v-list-item>
            <v-list-item @click="goToCharter()" v-if="user.UserSubType === 2 || user.UserSubType === 3 || user.UserSubType === 4">
              <v-list-item-icon>
                <v-icon class="m4u_text--text">mdi-currency-usd</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="m4u_text--text">Get $5 Amazon gift card</v-list-item-title>
            </v-list-item>
                <v-list-item @click="goToRoute('credits')" >
                  <v-list-item-icon>
                    <v-icon class="m4u_text--text">mdi-party-popper</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="m4u_text--text">Credits</v-list-item-title>
                </v-list-item>
            <v-list-item @click="adminPage()" v-if="user.AdminLevel === 100">
              <v-list-item-icon>
                <v-icon class="m4u_text--text">mdi-account-group</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="m4u_text--text">Admin Page</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon class="m4u_text--text">mdi-email-send-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="m4u_text--text"><a href="mailto: info@memoriesforus.com" class="black--text" style="text-decoration: none; color: inherit;">Email Us</a></v-list-item-title>              
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon class="m4u_text--text">mdi-spider</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="m4u_text--text"><a href="mailto: support@memoriesforus.com" class="black--text" style="text-decoration: none; color: inherit;">Report a Problem</a></v-list-item-title>              
            </v-list-item>
                <v-list-item router to="/Home">
              <v-list-item-action>
                <!-- show logout when authenticated -->
                <v-btn v-if="user !== undefined || user !== null" @click="logout()"
                  color="primary" dark class="m4u_text--text">
              <strong>Log out </strong></v-btn>
              </v-list-item-action>
            </v-list-item>

              </v-list-item-group>
            </v-list>
          </v-navigation-drawer>

</nav>
</template>

<script>
// import EventService from '@/services/EventService.js';

export default {
  name: "Nav",

  data() {
    return {
      circleNotice: '',
      drawer: false,
     links: [

//        {icon: 'mdi-home', text: 'Home', route: '/Home'},
        {icon: 'mdi-book-open-blank-variant', text: 'Books', route: '/Books'},
        {icon: 'mdi-google-circles-communities', text: 'Circles', route: '/Circles'},
        {icon: 'mdi-connection', text: 'QuickConnect', route: '/QuickConnect'},

      ],
      alertBell: false,
      isLoggedIn: '',
      predefinedBtnProps: {
          xs: {
            'x-small': true
          },
          sm: {
            'small': true
          },
          md: {
            
          },
          lg: {
            'large': true
          },
          xl: {
            'x-large': true
          }
        }
    };
  },
 mounted() {

  },

  computed: {
  user(){
    return this.$store.state.user
  },
  profileSas(){
    return this.$store.state.profileSas
  },

    loginState(){
    return this.$store.state.loginState
  },

            btnProps()  {
          let props = {}
          switch(this.$vuetify.breakpoint.name) {
            case 'xs':
              props.color = 'blue'
              props['x-small'] = true
              break
            case 'sm':
              props.color = 'blue'
              props['small'] = true
              break  
            case 'lg':
              props.color = 'green'
              props['large'] = true
              break
             case 'xl':
              props.color = 'purple'
              props['x-large'] = true
              break 
            default: 
              props.color = 'red'
          }
          return props
        }
        
  },

  methods: {
      goToRoute(setRoute) {
          this.drawer = false;
        this.$router.push(setRoute)
      },

      goToProfile() {
        this.$router.push({ name: 'userprofile', params: { profileID: this.user.UserID } }).catch(this.$store.dispatch('setProfile', this.user.UserID)) 
      },

      goTo30Days() {
        this.$router.push({ name: 'FreeDays'})
      },
      goToPolicies() {
        this.$router.push({ name: 'Policies'})
      },
      goToCharter() {
        this.$router.push({ name: 'CharterSuggestions'})
      },
      adminPage() {
        this.$router.push({ name: 'adminpage'})
      },

      logout() {
        sessionStorage.clear();
        this.$store.dispatch('logout');
        window.location.replace('/login');
      }
  }

};

</script>

<style>
 .navHeight {
   min-height: 4em;
 }

.notification {
  margin: 2px;
}

.userName {
  margin-left: 1em;
}
</style>